import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Xiazai"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M14.25 12.4835C14.3163 12.4835 14.3799 12.5098 14.4268 12.5567C14.4737 12.6036 14.5 12.6672 14.5 12.7335V13.75C14.5 13.8163 14.4737 13.8799 14.4268 13.9268C14.3799 13.9737 14.3163 14 14.25 14H1.75C1.6837 14 1.62011 13.9737 1.57322 13.9268C1.52634 13.8799 1.5 13.8163 1.5 13.75V12.7335C1.5 12.6672 1.52634 12.6036 1.57322 12.5567C1.62011 12.5098 1.6837 12.4835 1.75 12.4835H14.25ZM9.625 1V6.192H10.9315V6.1995C10.9515 6.1985 10.9705 6.1965 10.991 6.1965C11.541 6.1965 11.988 6.6195 11.988 7.1415C11.988 7.3845 11.888 7.6035 11.729 7.771L8.741 10.9215C8.556 11.1115 8.294 11.2345 8 11.2345C7.86204 11.2349 7.72545 11.2071 7.59857 11.153C7.47168 11.0988 7.35716 11.0194 7.262 10.9195L4.268 7.773C4.10593 7.60241 4.01446 7.37679 4.012 7.1415C4.012 6.6195 4.459 6.1965 5.009 6.1965C5.017 6.1965 5.024 6.198 5.032 6.198V6.192H6.375V1H9.625Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var xiazai = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xiazai as default };
